<template>
	<dialog-slot
			:title="title"
			@updateClose="onCloseDialog"
			@updateSave="onSave"
			apply-text="Add to table"
			:is-btn-safe="$v.$invalid"
			width="450px"
	>
		<field
				:classError="$v.notes.$error"
				margin="0"
				min-height="100px"
				width="480"
				label="Notes"
				placeholder="Enter notes"
				:setInputValue="notes"
				@updateInput="onInput($event, 'notes')"
				is-auto-grow
				is-textarea
				is-required
		></field>

		<div class="attention">
			<svg-sprite icon-id="attention" width="16" height="16"></svg-sprite>
			<div class="text baseGray">The comment will be added after saving changes to exceptions</div>
		</div>

	</dialog-slot>
</template>

<script>
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";

import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import getDefaultDate from "@/helper/getDefaultDate";
export default {
	name: "AddComment",
	mixins: [ validationMixin ],
	components: { DialogSlot },
	props: {
		title: String
	},
	data: () => ({
		notes: ""
	}),
	validations() {
		return {
			notes: { required }
		};
	},
	methods: {
		onCloseDialog() {
			this.$emit("updateCloseDialog");
		},

		onInput({ value }, key) {
			this[key] = value;
		},

		onSave() {
			this.$v.$touch();
			if (this.$v.$invalid) return;

			this.$emit("updateSaveComment", {
				description: this.notes,
				time: getDefaultDate(1, null, true),
				date: getDefaultDate(1, null, true)
			});
		}
	},
};
</script>

<style scoped lang="scss">
.attention {
	display: flex;
	align-items: center;
	gap: 4px;
	margin: 10px 0 0 ;
	color: var(--base-orange);
	font-size: 12px;
}
</style>
